import { render } from "./StudioMessagesTable.vue?vue&type=template&id=af4394e8"
import script from "./StudioMessagesTable.vue?vue&type=script&lang=js"
export * from "./StudioMessagesTable.vue?vue&type=script&lang=js"

import "./StudioMessagesTable.vue?vue&type=style&index=0&id=af4394e8&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__